var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ghost-item",class:_vm.inline ? 'c-ghost-item--inline': '',style:(_vm.cCustomVars)})}
var staticRenderFns = []

export { render, staticRenderFns }